module.exports = __webpack_public_path__ + "h5/img/seach1.ede65ee9.png";